import { authedFetch } from "./api";
import { orThrow } from "./http";

export interface CatalogCard {
  card_id: number;
  issuer: string;
  card_name: string;
  last_read_on: string | null;
  last_complete_on: string | null;
  read_complete: number | boolean | null;
}

export interface CatalogOffer extends CatalogCard {
  capture_key: string;
  merchant: string;
  title: string | null;
  expires_on: string | null;
  enrolled: number | boolean;
  last_seen_on: string;
  details?: string | null;
  fine_print?: string | null;
  max_reward?: number | null;
}

export interface OfferCatalog {
  today: string;
  offers: CatalogOffer[];
  cards: CatalogCard[];
  retention_days: number;
}

export async function searchOfferCatalog(merchant: string): Promise<OfferCatalog> {
  const query = new URLSearchParams({ merchant: merchant.trim() });
  const res = await authedFetch(`/api/offers/capture/catalog?${query}`, { cache: "no-store" });
  return await orThrow(res, "Could not search captured offers") as OfferCatalog;
}

export function hasCompleteCheck(card: CatalogCard): boolean {
  return Boolean(card.last_read_on && card.read_complete);
}
